import { useEffect, useLayoutEffect } from 'react';
import { useDispatch } from 'react-redux';
import WidgetsContent from "./WidgetsContent";
import { getWidgetsInit, windowWidthChanged } from '@/common/actions/widgetActions';
import { getGridColumns } from '@/common/utilities/widgetHelper';

export const HomepageContent = () => {
  const dispatch = useDispatch();
  let timeoutId: any;
  
  useEffect(() => {
    dispatch(getWidgetsInit());
  }, []);

  const getContainerWidth = () => {
    const container = document.getElementById('homepage-exploration-grid');
    if (container) {
      let containerWidth = container.clientWidth;
      if (getGridColumns(window.innerWidth) > 1){
        // 15px is browser scrollbar width (window.innerWidth - document.body.clientWidth). on the initial load, scrollbar does not appear and hence we need to subtract it to get correct width
        containerWidth = (window.innerWidth === containerWidth) ? (containerWidth - 15) : containerWidth
      }
      containerWidth = containerWidth - (2 * parseFloat(window.getComputedStyle(container).paddingLeft));
      return containerWidth;
    }
    return 1;
  }

  useLayoutEffect(() => {
    const handleResize = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        dispatch(windowWidthChanged(window.innerWidth,getContainerWidth()));
      }, 200)
    };
    window.addEventListener('resize', handleResize);
    dispatch(windowWidthChanged(window.innerWidth,getContainerWidth()));
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <WidgetsContent></WidgetsContent>
  );
}

export default HomepageContent;